import useResponseHandler from "../responses/responseHandler";
import axios from "axios";
import { API_PATH } from "../constants";

const useHttpAPI = () => {

  const axiosInstance = axios.create({
    baseURL: API_PATH
  });

  const { handleError } = useResponseHandler();

  const send = async(method, url, data) => {
    try {
      const pathUrl = `/${url.replace(/^\/*/, '')}`; // we add the '/', so trim any from start of the url
      const response = await axiosInstance.request({
        method: method,
        url: pathUrl,
        data: data
      });
      return response.data;
    }
    catch(error) {
      handleError(error);
      throw error;
    }
  };

  // used for raw http calls where we do not want to manipulate the url
  // or headers collection (e.g., making 'PUT' call to cloud storage)
  const request = async(config) => {
    try {
      const response = await axiosInstance.request(config);
      return response.data;
    }
    catch(error) {
      handleError(error);
      throw error;
    }
  };

  const get = async (url) => await send('get', url);

  const post = async (url, data) => await send('post', url, data);

  const put = async (url, data) => await send('put', url, data);

  return { get, post, put, request };
};

export { useHttpAPI };